export enum FirebaseCollections{
    Devices = 'devices',
    Events = 'events',
    Festivals = 'festivals',
    Articles = 'articles',
}
